import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
export const BookmarkPromptIcon = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 14 14"
    >
      <path
        d="M9.73806 11.6667L6.99939 9.74966L4.26072 11.6667C4.21203 11.7008 4.15493 11.7209 4.09563 11.7248C4.03632 11.7286 3.97709 11.7162 3.92437 11.6888C3.87165 11.6613 3.82747 11.62 3.79661 11.5692C3.76576 11.5184 3.74943 11.4601 3.74939 11.4007V2.92466C3.74939 2.75227 3.81787 2.58694 3.93977 2.46504C4.06167 2.34314 4.227 2.27466 4.39939 2.27466H9.59939C9.77178 2.27466 9.93711 2.34314 10.059 2.46504C10.1809 2.58694 10.2494 2.75227 10.2494 2.92466V11.4007C10.2494 11.4601 10.233 11.5184 10.2022 11.5692C10.1713 11.62 10.1271 11.6613 10.0744 11.6888C10.0217 11.7162 9.96245 11.7286 9.90315 11.7248C9.84385 11.7209 9.78675 11.7008 9.73806 11.6667Z"
        fill="transparent"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);
